(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('CommunicationEntityDeleteController',CommunicationEntityDeleteController);

    CommunicationEntityDeleteController.$inject = ['$uibModalInstance', 'entity', 'CommunicationEntity', 'Notification'];

    function CommunicationEntityDeleteController($uibModalInstance, entity, CommunicationEntity, Notification) {
        var vm = this;

        vm.communicationEntity = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CommunicationEntity.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                },
                function (error) {
                    Notification.error({ message: error.data.detail });
                    $uibModalInstance.close(true);
                });
        }
    }
})();
